import img_logo from '../img/logo/logo_color.png';
import restaurant_name from '../img/logo/restaurant_name.png';

import React, { Component } from 'react';
import '../css/main.css';


import { connect } from "react-redux";
import {  post_category, post_food, post_allergen, post_image } from '../api/UserFunctions';
import { changeCategories, changeFoods, changeAllergens, changeImages, changeCount } from "../actions/index";
import Footer from './Footer';
import CategoryWrapperAdmin from './CategoryWrapperAdmin';
import CategoryWrapper from './CategoryWrapper';

var jwtDecode = require('jwt-decode');



const mapStateToProps = state => {
	return { categories: state.categories, foods: state.foods, allergens: state.allergens, images: state.images, count: state.count, connexion: state.connexion, style_popup: state.style_popup, text_popup: state.text_popup };
  }; 

  function mapDispatchToProps(dispatch) {
    return {
      changeCategories:categories => dispatch(changeCategories(categories)),
      changeFoods:foods => dispatch(changeFoods(foods)),
      changeAllergens:allergens => dispatch(changeAllergens(allergens)),
      changeImages:images => dispatch(changeImages(images)),
	  changeCount:count => dispatch(changeCount(count))
    };
}

class Home extends Component {
	constructor(props){
		super(props);

		this.state = {
			style_category : {display: "none"},
			style_food     : {display: "none"},
			category_name  : "",
			category_text  : "",
			food_text  : "",
			menu_class     : "links",
			check          : 0,
			food_name      : "",
			description    : "",
			price          : 0,
			allergen1      : "Aucun",
			allergen2      : "Aucun",
			allergen3      : "Aucun",
			allergen4      : "Aucun",
			allergen5      : "Aucun",
			allergen6      : "Aucun",
			allergen7      : "Aucun",
			allergen8      : "Aucun",
			stock          : "oui",
			dayfood        : "non",
			category_choice: "",
			selectedFile   : null,
			index          : 0,
			test_image     : false,
			style_popup    : {display:"none"},
			text_popup     : "",
			type_popup     : "success",
			style_popup2    : {display:"none"},
			text_popup2     : "",
			type_popup2     : "success",
			checked         : "non"
		}
		this.onChange                   = this.onChange.bind(this);
		this.onSubmitCategory           = this.onSubmitCategory.bind(this);
		this.handleCreateCategory       = this.handleCreateCategory.bind(this);
		this.handleCreateFood       	   = this.handleCreateFood.bind(this);
		this.handleClose                = this.handleClose.bind(this);
		this.handleClosePopup                = this.handleClosePopup.bind(this);
		this.handleConfPopup                = this.handleConfPopup.bind(this);
		this.renderCategoryWrapperAdmin = this.renderCategoryWrapperAdmin.bind(this);
		this.renderCategoryChoice       = this.renderCategoryChoice.bind(this);
		
		this.handleResponsiveNavbar 		   = this.handleResponsiveNavbar.bind(this);
		this.handlePostFood 		          = this.handlePostFood.bind(this);
		this.handleA 		          = this.handleA.bind(this);
		this.popupParentCallback = this.popupParentCallback.bind(this);
		this.popupParentCallback2 = this.popupParentCallback2.bind(this);
		this.chackLoginStatus = this.checkLoginStatus.bind(this);
		
  	}

	  checkLoginStatus(){
		if(this.props.connexion){
		  if (jwtDecode(localStorage.getItem('usertoken')).exp < Date.now() / 1000) {
			localStorage.setItem('user',false);
			window.location.href=process.env.REACT_APP_ADMIN;
		  }
		}
		
	
	
	  }

	  popupParentCallback(style,text,type){
		this.setState({style_popup:style});
		this.setState({text_popup:text});
		this.setState({type_popup:type});
	  }

	  popupParentCallback2(style,text,type){
		this.setState({style_popup2:style});
		this.setState({text_popup2:text});
		this.setState({type_popup2:type});
	  }


	  

	handleResponsiveNavbar(){
		console.log("enter : "+this.state.menu_class);
		
		if(this.state.menu_class.localeCompare("links")==0 && (this.state.check == 1) ){
			this.setState({menu_class:"links opened"});
			this.setState({checked:"checked"});
		}
		else if(this.state.check==0 || this.state.check==3){
			this.setState({menu_class:"links"});
			this.setState({checked:"non"});
		}

		if(this.state.check == 3){
			this.setState({check:0});
		}
		else{
			this.setState({check:this.state.check+1});
		}
	}

	onChange(e) {
		this.setState({ [e.target.name]: e.target.value })
	}

	

	handleCreateCategory(e){
		this.setState({style_category:{display:"inline-flex"}});
	}

	onFileChange = event => { 
		// Update the state 
		this.setState({ selectedFile: event.target.files[0] });   
	}; 

	

	handleCreateFood(e){
		this.setState({style_food:{display:"inline-flex"}});
	}

	handleA(e,str){
		e.preventDefault();
		let offsetTop  = document.getElementById(str).offsetTop;
		window.scrollTo({
			top: offsetTop-100, 
			behavior: "smooth"
		});
		if(this.state.menu_class.localeCompare("links")==0 ){
			this.setState({menu_class:"links opened"});
			this.setState({checked:"checked"});
		}
		else{
			this.setState({menu_class:"links"});
			this.setState({checked:"non"});
		}
		this.setState({check:0});
	}

	handleClose(event) {
		event.preventDefault();
		console.log("okk");
		const target = event.target;
		if (target.id !== 'admin-pop-up-1' && target.id !== 'admin-pop-up-2' && target.id !=='admin-pop-up-3') {
		return ;
		}
		this.setState({style_category:{display:"none"},category_text:"",category_name:""});
		this.setState({style_food:{display:"none"},food_text:"",food_name:""});
		this.setState({style_popup:{display:"none"},text_popup:"",type_popup:"success"});
	}

	handleClosePopup(event) {
		event.preventDefault();
		this.setState({style_category:{display:"none"},category_text:"",category_name:""});
		this.setState({style_food:{display:"none"},food_text:"",food_name:""});
		this.setState({style_popup:{display:"none"},text_popup:"",type_popup:"success"});
		this.setState({style_popup2:{display:"none"},text_popup2:"",type_popup2:"success"});
	}

	handleConfPopup(event) {
		event.preventDefault();
	}

	handlePostFood(e) {
		e.preventDefault();

		var category_id;
		var stockString;
		var dayfoodString;

		if(this.state.stock.localeCompare("non")==0){
			stockString="false";
		}
		else{
			stockString="true";
		}

		if(this.state.dayfood.localeCompare("non")==0){
			dayfoodString="false";
		}
		else{
			dayfoodString="true";
		}

		this.props.categories.forEach((category,index) => {
			console.log(category["name"]+"id "+this.state.category_choice+"id");
			if(this.state.category_choice.localeCompare("")==0 && index == 0){
				category_id = category["id"];
			}
			else if(category["name"] == this.state.category_choice){
				category_id = category["id"];
			}
		  
		  });

		  var countSort = 0;
		  this.props.foods.forEach((food,index) => {
			
			if(food.id_category === category_id){
				countSort++;
			}
		  
		  });
		 // console.log(category["name"]+"id "+this.state.category_choice+"id");

		  

		const food = {
			name: this.state.food_name,
			id_category : category_id,
			description : this.state.description,
			is_active : stockString,
			is_emphased : dayfoodString,
			price: this.state.price,
			sortList : countSort+1
		}
		console.log("name "+this.state.food_name+"cat "+category_id+"des "+this.state.description+"act "+stockString+"day "+dayfoodString+"price "+this.state.price+"count "+food.sortList);

		if(food.name.localeCompare("") !== 0 && this.state.selectedFile !== null){
			post_food(food).then(res => {	
				console.log("res : "+JSON.stringify(res));		
				var keys = Object.keys(res);
				if(keys[0].localeCompare("error")==0){
				this.setState({food_text:"Ce plat existe déjà !"});
				}
				else{                  
				this.setState({food_text:"Nouveau plat créé avec succès !"});

				if(typeof(this.props.foods[0]) !== "undefined"){
					console.log("home post "+dayfoodString);
					var total = this.props.foods;
					total.push(res);
					this.props.changeFoods(total);
					this.setState({index:this.state.index+100});
					
				}

				if(this.state.allergen1.localeCompare("Aucun")!==0){
					const allergen1 = {
						name: this.state.allergen1,
						id_food: parseInt(res["id"])					
					}
					post_allergen(allergen1).then(all => {
						if(typeof(this.props.allergens[0]) !== "undefined"){
							var total = this.props.allergens;
							
							total.push(all);
							this.props.changeAllergens(total);
							this.setState({index:this.state.index+2});
						}	
					});

					
				}

				if(this.state.allergen2.localeCompare("Aucun")!==0){
					const allergen2 = {
						name: this.state.allergen2,
						id_food: parseInt(res["id"])					
					}
					post_allergen(allergen2).then(all => {
						if(typeof(this.props.allergens[0]) !== "undefined"){
							var total = this.props.allergens;
							
							total.push(all);
							this.props.changeAllergens(total);
							this.setState({index:this.state.index+3});
						}	
					});
				}

				if(this.state.allergen3.localeCompare("Aucun")!==0){
					const allergen3 = {
						name: this.state.allergen3,
						id_food: parseInt(res["id"])					
					}
					post_allergen(allergen3).then(all => {
						if(typeof(this.props.allergens[0]) !== "undefined"){
							var total = this.props.allergens;
							
							total.push(all);
							this.props.changeAllergens(total);
							this.setState({index:this.state.index+4});
						}	
					});
				}

				if(this.state.allergen4.localeCompare("Aucun")!==0){
					const allergen4 = {
						name: this.state.allergen4,
						id_food: parseInt(res["id"])					
					}
					post_allergen(allergen4).then(all => {
						if(typeof(this.props.allergens[0]) !== "undefined"){
							var total = this.props.allergens;
							
							total.push(all);
							this.props.changeAllergens(total);
							this.setState({index:this.state.index+5});
						}	
					});
				}

				if(this.state.allergen5.localeCompare("Aucun")!==0){
					const allergen5 = {
						name: this.state.allergen5,
						id_food: parseInt(res["id"])					
					}
					post_allergen(allergen5).then(all => {
						if(typeof(this.props.allergens[0]) !== "undefined"){
							var total = this.props.allergens;
							
							total.push(all);
							this.props.changeAllergens(total);
							this.setState({index:this.state.index+6});
						}	
					});
				}

				if(this.state.allergen6.localeCompare("Aucun")!==0){
					const allergen6 = {
						name: this.state.allergen6,
						id_food: parseInt(res["id"])					
					}
					post_allergen(allergen6).then(all => {
						if(typeof(this.props.allergens[0]) !== "undefined"){
							var total = this.props.allergens;
							
							total.push(all);
							this.props.changeAllergens(total);
							this.setState({index:this.state.index+7});
						}	
					});
				}

				if(this.state.allergen7.localeCompare("Aucun")!==0){
					const allergen7 = {
						name: this.state.allergen7,
						id_food: parseInt(res["id"])					
					}
					post_allergen(allergen7).then(all => {
						if(typeof(this.props.allergens[0]) !== "undefined"){
							var total = this.props.allergens;
							
							total.push(all);
							this.props.changeAllergens(total);
							this.setState({index:this.state.index+8});
						}	
					});
				}

				if(this.state.allergen8.localeCompare("Aucun")!==0){
					const allergen8 = {
						name: this.state.allergen8,
						id_food: parseInt(res["id"])					
					}
					post_allergen(allergen8).then(all => {
						if(typeof(this.props.allergens[0]) !== "undefined"){
							var total = this.props.allergens;
							
							total.push(all);
							this.props.changeAllergens(total);
							this.setState({index:this.state.index+9});
						}	
					});
				}

				if(this.state.selectedFile !== null){
					const file = {
						id_food: parseInt(res["id"]),
						selectedFile:this.state.selectedFile					
					}
					post_image(file).then(res => {
						if(typeof(this.props.images[0]) !== "undefined"){
							var number = this.props.images[this.props.images.length-1].id+1;
							var newImage = {
								id:number,
								name:res["name"],
								id_food:res["id_food"]
							}
							console.log("img "+JSON.stringify(res))
							var total = this.props.images;
							total.push(res);
							this.props.changeImages(total);
							var count = 0;
							this.props.foods.forEach((food,index) => {
												
								if(category_id === food.id_category){
									count++;
								}
							
							});
					
							if(count>=4){
								count=4;
							}



							var big = [];
							var key = category_id;
							var puzzle  = {}
							puzzle[key] = count;
							this.props.count.forEach((counter,index) => {	
								
								var keys = Object.keys(counter);
								console.log("actualise "+category_id+" "+parseInt(keys[0]));		
								if( category_id === parseInt(keys[0])){
									console.log("actualise");
									big.push(puzzle);
								}
								else{
									big.push(counter);
								}
								
							
							});
								
							this.props.changeCount(big);
							this.setState({test_image:!this.state.test_image});
							
							
						}
					});

					
				}

				
				
				
				}
				this.setState({style_food:{display:"none"},food_text:"",food_name:"",description:"",price:0,allergen1:"Aucun",allergen2:"Aucun",allergen3:"Aucun",allergen4:"Aucun",allergen5:"Aucun",allergen6:"Aucun",allergen7:"Aucun",allergen8:"Aucun",stock:"oui",dayfood:"non"});
			});

			
			}
		else{
		this.setState({food_text:"Le nom et le fichier ne peuvent pas être vide !"});
		}	   
	}

	componentDidMount(){
		if(typeof(this.props.foods[0]) !== "undefined"){
			this.setState({foods_change:this.props.foods});
		}
		var big = [];
		this.props.categories.forEach((category,index) => {
			var count = 0;
			this.props.foods.forEach((food,index) => {
								
				if(category.id === food.id_category){
					count++;
				}
			  
			  });
	
			  if(count>=4){
				count=4;
			  }

			  var key = category.id;
			  var puzzle  = {}
			  puzzle[key] = count;
				  var bool = true;
				  
				this.props.count.forEach((counter,index) => {			
					var keys = Object.keys(counter);		
					if(category.id === parseInt(keys[0])){
						bool = false;
						big = [];
						big.push(puzzle);
						console.log("big1 "+JSON.stringify(big));
						
					}
					else{
						big.push(counter);
						console.log("big2 "+JSON.stringify(big));
					}
				  
				  });
				  if(bool){
					big.push(puzzle);
					bool=false;
					console.log("big3 "+JSON.stringify(big));
				  }
				  
				  
			  
			  
		});  
		console.log("big4 "+JSON.stringify(big));
		this.props.changeCount(big);
		var big = [];
	}
  	onSubmitCategory(e) {
		e.preventDefault();
		
		if(typeof(this.props.categories) !== "undefined"){
			const category = {
				name: this.state.category_name,
				sortList:this.props.categories.length+1
				}
		if(category.name.localeCompare("") !== 0){
			
			var total2 = this.props.count;
			post_category(category).then(res => {
				
				var keys = Object.keys(res);
				if(keys[0].localeCompare("error")==0){
				this.setState({category_text:"Cette catégorie existe déjà !"});
				}
				else{                  
				this.setState({category_text:"Nouvelle catégorie créée avec succès !"});
				if(typeof(this.props.categories[0]) !== "undefined"){
					var new1={
						id:res.id,
						name:res.name,
						sortList:this.props.categories.length+1
					  }	
					var total = this.props.categories;
					
					total.push(new1);
					console.log("new cat "+JSON.stringify(total))
					total.sort((a, b) => a.sortList - b.sortList);
					this.props.changeCategories(total);
					

				}

				
				var key = res["id"];
			  	var puzzle  = {}
			  	puzzle[key] = 0;
				  total2.push(puzzle);
				  this.props.changeCount(total2);
				}
				
				this.setState({index:this.state.index+100});
				
			});

			this.setState({style_category:{display:"none"},category_text:"",category_name:"",price:"",allergen1:"Aucun",allergen2:"Aucun",allergen3:"Aucun",allergen4:"Aucun",allergen5:"Aucun",allergen6:"Aucun",allergen7:"Aucun",allergen8:"Aucun",stock:"non",dayfood:"non",category_choice:"", selectedFile:null});

			

			
		
			}
		else{
		this.setState({category_text:"Le champ nom ne peut pas être vide !"});
		}	   
	}
	}

	renderCategoryWrapperAdmin(){
		
		var total = this.props.categories;
		total.sort((a, b) => a.sortList - b.sortList);
	return total.map((category,index) => {  
		return (
			<div key={index}>
				<CategoryWrapperAdmin selectSort={category.sortList} rerenderParentCallback={this.rerenderParentCallback} popupParentCallback2={this.popupParentCallback2} popupParentCallback={this.popupParentCallback} key={this.state.index} foods_change={this.state.foods_change} name={category.name} id={category.id} test_image={this.state.test_image}/>
			</div>		
		) 
	});  
	}

	renderCategoryWrapper(){
		
		var total = this.props.categories;
		total.sort((a, b) => a.sortList - b.sortList);
	return total.map((category,index) => {  
		return (
			<div key={index}>
				<CategoryWrapper selectSort={category.sortList} rerenderParentCallback={this.rerenderParentCallback} key={index} foods_change={this.state.foods_change} name={category.name} id={category.id} test_image={this.state.test_image}/>
			</div>		
		) 
	});  
	}

	renderCategoryChoice(){
		return this.props.categories.map((category,index) => {
			return (
				<option key={index} value={category.name}>{category.name}</option>		
			) 
		});  
		}

	renderA(){
		return this.props.categories.map((category,index) => {
			if(this.props.categories.length-1 === index){
				return (
					[<a style={{cursor:"pointer"}} key={index} onClick={(event) => this.handleA(event, category.name)}>{category.name}</a>,<a style={{cursor:"pointer"}} key={index} onClick={(event) => this.handleA(event, "contactus")}>QUI SOMMES-NOUS ?</a>]
				) 
			}
			{
				return (
					<a style={{cursor:"pointer"}} key={index} onClick={(event) => this.handleA(event, category.name)}>{category.name}</a>		
				) 
			}
			
		});  
	}

	render() {
		
		if(this.props.connexionAuth){
			return (
				<div>
					<nav>
						<div id="top-nav">
							<a href="#"><img className="logo" src={img_logo}/></a>
							<div className="control-responsive-navbar" onClick={() => this.handleResponsiveNavbar()}>
								<label htmlFor="check">
									<input type="checkbox" id="check" checked={this.state.checked === "checked"}/> 
									<span></span>
									<span></span>
									<span></span>
								</label>
							</div>
							<div className={this.state.menu_class}>
								{this.renderA()}
							</div>
						</div>
					</nav>
					<main >
						
						<section id="menu" >
							<div className="wrapper">
								<div id="admin-options">
									<button className="btn" onClick={(event) => this.handleCreateCategory(event)}>Ajouter catégorie</button>
									<button className="btn" onClick={(event) => this.handleCreateFood(event)}>Ajouter plat</button>
								</div>
								<div class="admin-pop-up-1" id="admin-pop-up-1" style={this.state.style_category}>
									<form >
										<input name="category_name" value={this.state.category_name} onChange={this.onChange} placeholder="Nom de la nouvelle catégorie"/>
										<input className="btn cancel" onClick={(event) => this.handleClosePopup(event)} type="submit" value="Annuler"/>
										<input className="btn" onClick={(event) => this.onSubmitCategory(event)} type="submit" value="Créer"/>
										<p id="category-response">{this.state.category_text}</p>
									</form>
								</div>
								<div class="admin-pop-up-2" id="admin-pop-up-2" style={this.state.style_food} >
									<form className="food-card" onSubmit={this.onSubmitFood}>
										<div className="header">
											<input type="text" name="id" value="ID" class="invisible"/>
											<input type="text" name="food_name" value={this.state.food_name}  onChange={this.onChange} className="title" placeholder="Nom du nouveau plat"/>
											<input type="number" step="0.01" name="price" value={this.state.price}  onChange={this.onChange} className="price" placeholder="Prix"/>
										</div>

										<input name="illustration" type="file" onChange={this.onFileChange} />
										
										<div className="footer">
											<textarea name="description" value={this.state.description}  onChange={this.onChange} className="description" placeholder="Description"/>
											<div class="categorySelectionWrapper">
												<p>Catégorie</p>
												<div className="custom-select-wrapper categories_list">
													<select name="category_choice" value={this.state.category_choice}  onChange={this.onChange}>
														{this.renderCategoryChoice()}
													</select>
												</div>
											</div>
											<div class="allergenWrapper">
												<p>Allergènes</p>
												<div className="custom-select-wrapper allergen">
													<select name="allergen1" value={this.state.allergen1}  onChange={this.onChange}>
														<option value="Aucun">Aucun</option>
														<option value="Gluten">Gluten</option>
														<option value="Fruits à coque">Fruits à coque</option>
														<option value="Oeuf">Oeuf</option>
														<option value="Poisson">Poisson</option>
														<option value="Soja">Soja</option>
														<option value="Lait">Lait</option>
														<option value="Crustacé">Crustacé</option>
														<option value="Mollusque">Mollusque</option>
														<option value="Céléri">Céléri</option>
														<option value="Moutarde">Moutarde</option>
														<option value="Sésame">Sésame</option>
														<option value="Lupin">Lupin</option>
														<option value="Anhydride sulfureux et sulfites">Anhydride sulfureux et sulfites</option>
														<option value="Arachide">Arachide</option>
													</select>
													<select name="allergen2" value={this.state.allergen2}  onChange={this.onChange}>
														<option value="Aucun">Aucun</option>
														<option value="Gluten">Gluten</option>
														<option value="Fruits à coque">Fruits à coque</option>
														<option value="Oeuf">Oeuf</option>
														<option value="Poisson">Poisson</option>
														<option value="Soja">Soja</option>
														<option value="Lait">Lait</option>
														<option value="Crustacé">Crustacé</option>
														<option value="Mollusque">Mollusque</option>
														<option value="Céléri">Céléri</option>
														<option value="Moutarde">Moutarde</option>
														<option value="Sésame">Sésame</option>
														<option value="Lupin">Lupin</option>
														<option value="Anhydride sulfureux et sulfites">Anhydride sulfureux et sulfites</option>
														<option value="Arachide">Arachide</option>
													</select>
													<select name="allergen3" value={this.state.allergen3}  onChange={this.onChange}>
														<option value="Aucun">Aucun</option>
														<option value="Gluten">Gluten</option>
														<option value="Fruits à coque">Fruits à coque</option>
														<option value="Oeuf">Oeuf</option>
														<option value="Poisson">Poisson</option>
														<option value="Soja">Soja</option>
														<option value="Lait">Lait</option>
														<option value="Crustacé">Crustacé</option>
														<option value="Mollusque">Mollusque</option>
														<option value="Céléri">Céléri</option>
														<option value="Moutarde">Moutarde</option>
														<option value="Sésame">Sésame</option>
														<option value="Lupin">Lupin</option>
														<option value="Anhydride sulfureux et sulfites">Anhydride sulfureux et sulfites</option>
														<option value="Arachide">Arachide</option>
													</select>
													<select name="allergen4" value={this.state.allergen4}  onChange={this.onChange}>
														<option value="Aucun">Aucun</option>
														<option value="Gluten">Gluten</option>
														<option value="Fruits à coque">Fruits à coque</option>
														<option value="Oeuf">Oeuf</option>
														<option value="Poisson">Poisson</option>
														<option value="Soja">Soja</option>
														<option value="Lait">Lait</option>
														<option value="Crustacé">Crustacé</option>
														<option value="Mollusque">Mollusque</option>
														<option value="Céléri">Céléri</option>
														<option value="Moutarde">Moutarde</option>
														<option value="Sésame">Sésame</option>
														<option value="Lupin">Lupin</option>
														<option value="Anhydride sulfureux et sulfites">Anhydride sulfureux et sulfites</option>
														<option value="Arachide">Arachide</option>
													</select>
													<select name="allergen5" value={this.state.allergen5}  onChange={this.onChange}>
														<option value="Aucun">Aucun</option>
														<option value="Gluten">Gluten</option>
														<option value="Fruits à coque">Fruits à coque</option>
														<option value="Oeuf">Oeuf</option>
														<option value="Poisson">Poisson</option>
														<option value="Soja">Soja</option>
														<option value="Lait">Lait</option>
														<option value="Crustacé">Crustacé</option>
														<option value="Mollusque">Mollusque</option>
														<option value="Céléri">Céléri</option>
														<option value="Moutarde">Moutarde</option>
														<option value="Sésame">Sésame</option>
														<option value="Lupin">Lupin</option>
														<option value="Anhydride sulfureux et sulfites">Anhydride sulfureux et sulfites</option>
														<option value="Arachide">Arachide</option>
													</select>
													<select name="allergen6" value={this.state.allergen6}  onChange={this.onChange}>
														<option value="Aucun">Aucun</option>
														<option value="Gluten">Gluten</option>
														<option value="Fruits à coque">Fruits à coque</option>
														<option value="Oeuf">Oeuf</option>
														<option value="Poisson">Poisson</option>
														<option value="Soja">Soja</option>
														<option value="Lait">Lait</option>
														<option value="Crustacé">Crustacé</option>
														<option value="Mollusque">Mollusque</option>
														<option value="Céléri">Céléri</option>
														<option value="Moutarde">Moutarde</option>
														<option value="Sésame">Sésame</option>
														<option value="Lupin">Lupin</option>
														<option value="Anhydride sulfureux et sulfites">Anhydride sulfureux et sulfites</option>
														<option value="Arachide">Arachide</option>
													</select>
													<select name="allergen7" value={this.state.allergen7}  onChange={this.onChange}>
														<option value="Aucun">Aucun</option>
														<option value="Gluten">Gluten</option>
														<option value="Fruits à coque">Fruits à coque</option>
														<option value="Oeuf">Oeuf</option>
														<option value="Poisson">Poisson</option>
														<option value="Soja">Soja</option>
														<option value="Lait">Lait</option>
														<option value="Crustacé">Crustacé</option>
														<option value="Mollusque">Mollusque</option>
														<option value="Céléri">Céléri</option>
														<option value="Moutarde">Moutarde</option>
														<option value="Sésame">Sésame</option>
														<option value="Lupin">Lupin</option>
														<option value="Anhydride sulfureux et sulfites">Anhydride sulfureux et sulfites</option>
														<option value="Arachide">Arachide</option>
													</select>
													<select name="allergen8" value={this.state.allergen8}  onChange={this.onChange}>
														<option value="Aucun">Aucun</option>
														<option value="Gluten">Gluten</option>
														<option value="Fruits à coque">Fruits à coque</option>
														<option value="Oeuf">Oeuf</option>
														<option value="Poisson">Poisson</option>
														<option value="Soja">Soja</option>
														<option value="Lait">Lait</option>
														<option value="Crustacé">Crustacé</option>
														<option value="Mollusque">Mollusque</option>
														<option value="Céléri">Céléri</option>
														<option value="Moutarde">Moutarde</option>
														<option value="Sésame">Sésame</option>
														<option value="Lupin">Lupin</option>
														<option value="Anhydride sulfureux et sulfites">Anhydride sulfureux et sulfites</option>
														<option value="Arachide">Arachide</option>
													</select>
												</div>
											</div>
											<div class="stockWrapper">
												<p>Stock</p>
												<div className="custom-select-wrapper stock">
													<select name="stock" value={this.state.stock}  onChange={this.onChange}>
														<option value="non">Non</option>
														<option value="oui">Oui</option>
													</select>
												</div>
											</div>
											<div class="dayfoodWrapper">
												<p>Plat du jour</p>
												<div className="custom-select-wrapper dayfood">
													<select name="dayfood" value={this.state.dayfood}  onChange={this.onChange}>
														<option value="non">Non</option>
														<option value="oui">Oui</option>
													</select>
												</div>
											</div>
										</div>
										<input className="btn cancel" type="submit" onClick={(event) => this.handleClosePopup(event)} value="Annuler"/>
										<input className="btn" type="submit" value="Créer" onClick={(event) => this.handlePostFood(event)}/>										
										<p id="food-response">{this.state.food_text}</p>
									</form>
								</div>
								<div id="admin-pop-up-3" className="popup-confirmation" style={this.state.style_popup} >
									<div className={"popup-wrapper " + this.state.type_popup}>
										<p>{this.state.text_popup}</p>
										<button className="btn" onClick={(event) => this.handleClosePopup(event)}>Retour</button>
									</div>
								</div>
								{this.renderCategoryWrapperAdmin()}
							</div>
						</section>
					</main>
					<Footer/>
				</div>
			);
		}
		
		
		else{
			
			
			return (
				
				<div>
				
					<nav>
						<div id="top-nav">
							<a href="#"><img className="logo" src={img_logo}/></a>
							<div className="control-responsive-navbar"  ref={input => this.inputElement = input} onClick={(event) => this.handleResponsiveNavbar(event)} >
								<label htmlFor="check">
									{}<input type="checkbox" id="check" checked={this.state.checked === "checked"}/> 
									<span></span>
									<span></span>
									<span></span>
								</label>
							</div>
							<div className={this.state.menu_class}>
								{this.renderA()}
							</div>
						</div>
					</nav>

					<main>
					
						<div className="hero-wrapper">
							<div className="wrapper">
								<div className="hero-content">
									<img className="logo" src={img_logo}/>
									<img className="restaurantName" src={restaurant_name}/>
									<p className="subtitle">Découvrez l'authenticité de la cuisine Ouest Africaine</p>
								</div>
							</div>
						</div>
						<section id="menu">
								<div className="wrapper">
									{this.renderCategoryWrapper()}
								</div>
						</section>
					</main>
					<Footer/>
				</div>
			);
			
		}
  }
  
}
export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/components/Home.js